import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { ProgramacionCorreoDto } from '../administracion/data/programacionCorreoDto';
import { ReportesState } from './reportes.model';
import * as fromReportesAction from './reportes.actions';
import * as fromSelectorAction from './reportes.selectors';

@Injectable({
  providedIn: 'root'
})
export class ReportesStoreService {

  constructor(private store: Store<ReportesState>) {
  }

  // eslint-disable-next-line @typescript-eslint/naming-convention, no-underscore-dangle, id-blacklist, id-match
  public adicionarInformacionFiltroCorreo(_newProgramacionCorreoDto: ProgramacionCorreoDto): void {
    this.store.dispatch(
      fromReportesAction.addProgramacionCorreo({
        _newProgramacionCorreoDto: { ..._newProgramacionCorreoDto }
      }));
  }

  public removeInformacionFiltroCorreo(): void {
    this.store.dispatch(
      fromReportesAction.removeProgramacionCorreo());
  }

  // COM Selectores ********************
  public obtenerInformacionFiltroCorreo$(): Observable<ProgramacionCorreoDto> {
    return this.store.select(fromSelectorAction.selectInformacionCorreo);
  }

}
